import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'

export const useInscricoesStore = defineStore('inscricoes', () => {
  const items = ref([])
  const meta = ref({ total: 0, page: 1, limit: 30, pages: 1 })
  const loading = ref(false)

  async function fetch(params = {}) {
    loading.value = true
    try {
      const { data } = await api.get('/inscricoes', { params })
      items.value = data.inscricoes
      meta.value = data.meta
    } finally { loading.value = false }
  }

  async function getOne(id) {
    const { data } = await api.get(`/inscricoes/${id}`)
    return data.inscricao
  }

  async function updateAnotacao(id, anotacao) {
    const { data } = await api.patch(`/inscricoes/${id}/anotacao`, { anotacao })
    items.value = items.value.map(i => i.id === id ? { ...i, anotacao: data.inscricao.anotacao } : i)
  }

  async function sync(id) {
    const { data } = await api.post(`/inscricoes/${id}/sync`)
    return data
  }

  async function cancelar(id) {
    const { data } = await api.post(`/inscricoes/${id}/cancelar`)
    return data
  }

  function applyPusherUpdate({ inscricaoId, statusPagamento }) {
    items.value = items.value.map(i =>
      i.id === inscricaoId ? { ...i, statusPagamento } : i
    )
  }

  return { items, meta, loading, fetch, getOne, updateAnotacao, sync, cancelar, applyPusherUpdate }
})
